const BASE_ID = 100000;

const INTERVAL_TYPE = 
{
    '1sec': 1,
    '1min': 60,
    '10min': 600
}

const MONITOR_PARAMETERS = {
    hr: "HR",
    rr: "RR",
    spo2: "SPO₂",
    pr: "PR",
    pi: "PI",
    temperature1: "TEMP1",
    temperature2: "TEMP2",
    systolic: "SYS",
    diastolic: "DIA",
    mean: "MEAN",
    etco2: "EtCO₂",
    fico2: "FiO₂",
    aw_rr: "AW RR",
    ibp1_systolic: "IBP1 SYS",
    ibp1_diastolic: "IBP1 DIA",
    ibp1_mean: "IBP1 MEAN",
    ibp2_systolic: "IBP2 SYS",
    ibp2_diastolic: "IBP2 DIA",
    ibp2_mean: "IBP2 MEAN",
}


const stringToIntervalType = (key) => {
    if (key == "1sec") return INTERVAL_TYPE['1sec'];
    if (key == "1min") return INTERVAL_TYPE['1min'];
    if (key == "10min") return INTERVAL_TYPE['10min'];
    return null;
}

const intervalSecondsToIntervalType = (seconds) => {
    if (seconds == 1) return '1sec';
    if (seconds == 60) return '1min';
    if (seconds == 600) return '10min';
    return null;
}

const keyToId = (key) => {
    if(key == MONITOR_PARAMETERS['hr'])               return BASE_ID + 101;
    if(key == MONITOR_PARAMETERS['rr'])               return BASE_ID + 102;
    if(key == MONITOR_PARAMETERS['spo2'])             return BASE_ID + 103;
    if(key == MONITOR_PARAMETERS['pr'])               return BASE_ID + 104;
    if(key == MONITOR_PARAMETERS['pi'])               return BASE_ID + 105;
    if(key == MONITOR_PARAMETERS['temperature1'])     return BASE_ID + 106;
    if(key == MONITOR_PARAMETERS['temperature2'])     return BASE_ID + 107;
    if(key == MONITOR_PARAMETERS['systolic'])         return BASE_ID + 108;
    if(key == MONITOR_PARAMETERS['diastolic'])        return BASE_ID + 109;
    if(key == MONITOR_PARAMETERS['mean'])             return BASE_ID + 110;
    if(key == MONITOR_PARAMETERS['etco2'])            return BASE_ID + 111;
    if(key == MONITOR_PARAMETERS['aw_rr'])            return BASE_ID + 112;
    if(key == MONITOR_PARAMETERS['ibp1_systolic'])    return BASE_ID + 113;
    if(key == MONITOR_PARAMETERS['ibp1_diastolic'])   return BASE_ID + 114;
    if(key == MONITOR_PARAMETERS['ibp1_mean'])        return BASE_ID + 115;
    if(key == MONITOR_PARAMETERS['ibp2_systolic'])    return BASE_ID + 116;
    if(key == MONITOR_PARAMETERS['ibp2_diastolic'])   return BASE_ID + 117;
    if(key == MONITOR_PARAMETERS['ibp2_mean'])        return BASE_ID + 118;
    if(key == MONITOR_PARAMETERS['fico2'])            return BASE_ID + 119;
   
    return null;
}

const idToKey = (id) => {
    if (id == BASE_ID + 101) return MONITOR_PARAMETERS['hr'];
    if (id == BASE_ID + 102) return MONITOR_PARAMETERS['rr'];
    if (id == BASE_ID + 103) return MONITOR_PARAMETERS['spo2'];
    if (id == BASE_ID + 104) return MONITOR_PARAMETERS['pr'];
    if (id == BASE_ID + 105) return MONITOR_PARAMETERS['pi'];
    if (id == BASE_ID + 106) return MONITOR_PARAMETERS['temperature1'];
    if (id == BASE_ID + 107) return MONITOR_PARAMETERS['temperature2'];
    if (id == BASE_ID + 108) return MONITOR_PARAMETERS['systolic'];
    if (id == BASE_ID + 109) return MONITOR_PARAMETERS['diastolic'];
    if (id == BASE_ID + 110) return MONITOR_PARAMETERS['mean'];
    if (id == BASE_ID + 111) return MONITOR_PARAMETERS['etco2'];
    if (id == BASE_ID + 112) return MONITOR_PARAMETERS['aw_rr'];
    if (id == BASE_ID + 113) return MONITOR_PARAMETERS['ibp1_systolic'];
    if (id == BASE_ID + 114) return MONITOR_PARAMETERS['ibp1_diastolic'];
    if (id == BASE_ID + 115) return MONITOR_PARAMETERS['ibp1_mean'];
    if (id == BASE_ID + 116) return MONITOR_PARAMETERS['ibp2_systolic'];
    if (id == BASE_ID + 117) return MONITOR_PARAMETERS['ibp2_diastolic'];
    if (id == BASE_ID + 118) return MONITOR_PARAMETERS['ibp2_mean'];
    if (id == BASE_ID + 119) return MONITOR_PARAMETERS['fico2'];
    return null;
}

module.exports = {
    keyToId,
    idToKey,
    stringToIntervalType,
    intervalSecondsToIntervalType,
    MONITOR_PARAMETERS,
    INTERVAL_TYPE
}